import React from 'react';

export default function PauseIcon({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.25 5V4.25H7.75V5V19V19.75H9.25V19V5ZM16.25 5V4.25H14.75V5V19V19.75H16.25V19V5Z"
        fill={color}
      />
    </svg>
  );
}
